import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { projectSettingsToolchainResource } from '@jira/router-resources__project-settings-toolchain/src/projectSettingsToolchainResource.tsx';
import ErrorPagesNotFound from '@jira/router-routes__common/src/ui/error-pages/not-found/index.tsx';
import { isDevopsFeatureDisabledInFedRamp } from '@jira/software__devops-fedramp-utils/src/isDevopsFeatureDisabledInFedRamp.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import componentWithCondition from '@jira/platform__component-with-condition/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { projectSettingsToolchainRoute } from '@jira/router-routes__project-settings-product-routes-software-routes/src/projectSettingsToolchainRoute.tsx';
import { softwareProjectLayoutNoOnboarding } from '@jira/platform__layouts-software-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import DevOpsConnectionsSettings, {
	LazyDevOpsConnectionsSettings,
} from './ui/project-settings/connections/index.tsx';
import { getSettingsNavigationResources } from './ui/project-settings/product-routes/common/index.tsx';

export const projectSettingsToolchainRouteEntry: Route = createEntry(
	projectSettingsToolchainRoute,
	() => ({
		group: 'project-settings-software',

		// eslint-disable-next-line no-restricted-syntax
		component: componentWithCondition(
			isDevopsFeatureDisabledInFedRamp,
			ErrorPagesNotFound,
			DevOpsConnectionsSettings,
		),

		layout: softwareProjectLayoutNoOnboarding,
		resources: [...getSettingsNavigationResources(), projectSettingsToolchainResource],

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		forPaint: [LazyAtlassianNavigation, LazyDevOpsConnectionsSettings],
		ufoName: 'project-settings.devops-connections',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
